import { css } from '@emotion/react'
import { IPartnerLanding } from 'api/contentful/contentful.types'
import { Block } from 'components/Block'
import { BorderDecoration } from 'components/BorderDecoration'
import { Button } from 'components/button/Button'
import { SLeftDiv, SPartnerAction, SRightDiv } from './PartnerAction.styled'
import { Icon } from 'components/icon'
import { ParallaxImage } from 'components/Parallax'
import { Spacer } from 'components/spacer/Spacer'
import { Text, Title, Title_h3_default } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export function PartnerAction(props: {
  className?: string
  partnerLandingCms?: IPartnerLanding
  onAction: () => void
}) {
  return (
    <Block className={props.className} css={{ overflow: 'hidden' }}>
      <SPartnerAction>
        <SLeftDiv>
          <ParallaxImage
            src={`/images/aboutHero.jpg`}
            srcSet={`
              /images/aboutHero.jpg 1x,
              /images/aboutHero@2x.jpg 2x,
            `}
            alt="GoodTrust"
            css={css`
              width: 100%;

              @media ${BREAKPOINTS.MD.max} {
                max-height: 20vh;
                object-fit: cover;
                margin-left: 5vw;
              }
            `}
          />
        </SLeftDiv>

        <SRightDiv>
          <div
            css={css`
              position: relative;
              padding-bottom: 4rem;
            `}
          >
            <BorderDecoration
              top={-43}
              right={0}
              bottom={0}
              left="var(--p-button)"
              css={css`
                @media ${BREAKPOINTS.MD.max} {
                  display: none;
                }
              `}
            />

            <Title
              variant={Title_h3_default}
              as="h2"
              css={{ marginBottom: '1.25rem', maxWidth: '30rem' }}
            >
              {props?.partnerLandingCms?.actionTitle}
            </Title>

            <Text>{props?.partnerLandingCms?.actionDescription}</Text>

            <Spacer size={[1.5, 2.375]} />

            <Button
              variant="text"
              size="large"
              leftIcon={<Icon name="Plus" />}
              type="button"
              onClick={props.onAction}
            >
              Start now
            </Button>
          </div>
        </SRightDiv>
      </SPartnerAction>
    </Block>
  )
}
